import React, { useContext } from 'react';
import Navbar from '../components/Navbar';
import { Link, useParams } from 'react-router-dom';
import { Button } from 'antd';
import '../styles/styles.css';
import { StateContext } from '../App';

export default function Instructions() {
  const { tema, sections } = useContext(StateContext);
  const [site = 'cdmx'] = Object.values(useParams());
  return (
    <div
      className="instrucciones"
      style={{ backgroundImage: `url("${tema.instructionsImage}")` }}
    >
      <Navbar />
      <section className="boxInstruc">
        {sections.en && (
          <article
            dangerouslySetInnerHTML={{
              __html: sections.en.instructions[site],
            }}
          ></article>
        )}

        <Link to="/form">
          <Button className="botonJugar" type="primary">
            Play
          </Button>
        </Link>
        {sections.en && (
          <article
            className="footerNotice"
            dangerouslySetInnerHTML={{
              __html: sections.en.footer[site],
            }}
          ></article>
        )}
      </section>
    </div>
  );
}
